import { getDomesticFlatRate } from '@util/firestore/shipengine';
import { getDefaultAddress } from '@util/firestore/users/user.service';
import type { ProductLight } from 'models/product';
import type { UserDocument } from 'models/user';

type ListProductShippingEstimateProps = {
  product: ProductLight;
  userDoc: UserDocument | null | undefined;
};

export const ListProductShippingEstimate = (
  props: ListProductShippingEstimateProps
) => {
  const isMXLockerDirect =
    props.product.seller_id === 'E16WuBcn0UMejlp0FSdQulSSed12';
  const deliveryRange = isMXLockerDirect ? '1-3' : '2-5';
  const defaultAddress = getDefaultAddress(props.userDoc);
  const isFreeFlatRate =
    props.product.is_flat_rate &&
    props.product.shipping_costs?.every(({ cost }) => cost === 0);
  const isFreeDomestic =
    !!defaultAddress &&
    getDomesticFlatRate(props.product, defaultAddress) === 0;

  if (!isFreeFlatRate && !isFreeDomestic) return null;

  if (isMXLockerDirect) {
    return (
      <span className="text-[1.6rem] font-medium text-zinc-500 sm:text-[1.8rem]">
        Free delivery in {deliveryRange} biz days
      </span>
    );
  }

  return (
    <span className="text-[1.6rem] font-medium text-zinc-500 sm:text-[1.8rem]">
      Free delivery
    </span>
  );
};
